// neo_cogym — WiFi 릴레이 전송 (P2: 전 디바이스, iPad 포함 기본 경로)
// 브라우저 ↔ Cloudflare Durable Object(WSS:443) ↔ 코드위즈(ESP32 WiFi STA)
// 같은 roomId 로 접속한 피어 간 바이트를 양방향 중계. REPL 제어바이트는 그대로 통과.
//
// ⚠️ 검증 필요(P2): ESP32 펌웨어가 WSS 아웃바운드(릴레이 접속)와 MicroPython 상주를
//    실제로 지원하는지는 하드웨어로 확인해야 함(T3 spec §2). 이 클라이언트는 그 전제하에
//    브라우저 측 절반을 완성한 것.

import type { Transport, TransportKind } from "./transport";

export interface RelayConfig {
  /** 릴레이 WSS 베이스 (예: wss://app.neo-cogym.com/relay) */
  baseUrl: string;
  /** 기기-브라우저를 묶는 방 ID(페어링 코드) */
  roomId: string;
  /** 인증 토큰(선택) */
  token?: string;
}

export class RelayTransport implements Transport {
  readonly kind: TransportKind = "relay";
  private ws: WebSocket | null = null;
  private listeners = new Set<(c: Uint8Array) => void>();
  private _open = false;

  get isOpen() {
    return this._open;
  }

  constructor(private cfg: RelayConfig) {}

  open(): Promise<void> {
    return new Promise((resolve, reject) => {
      const q = this.cfg.token ? `?token=${encodeURIComponent(this.cfg.token)}` : "";
      const url = `${this.cfg.baseUrl.replace(/\/$/, "")}/${encodeURIComponent(this.cfg.roomId)}${q}`;
      const ws = new WebSocket(url);
      ws.binaryType = "arraybuffer";
      this.ws = ws;

      ws.onopen = () => {
        this._open = true;
        resolve();
      };
      ws.onerror = () => reject(new Error("릴레이 연결 실패"));
      ws.onclose = () => {
        this._open = false;
      };
      ws.onmessage = (ev) => {
        const data =
          ev.data instanceof ArrayBuffer
            ? new Uint8Array(ev.data)
            : typeof ev.data === "string"
              ? new TextEncoder().encode(ev.data)
              : null;
        if (data) for (const cb of this.listeners) cb(data);
      };
    });
  }

  async write(data: Uint8Array): Promise<void> {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      throw new Error("릴레이가 열리지 않음");
    }
    // 복사본 전송(detach된 버퍼 이슈 방지)
    this.ws.send(data.slice().buffer);
  }

  onData(cb: (c: Uint8Array) => void): () => void {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  }

  async close(): Promise<void> {
    this._open = false;
    this.ws?.close();
    this.ws = null;
    this.listeners.clear();
  }
}
